import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\GetItemsByPlacesController::__invoke
* @see app/Http/Controllers/WikiPlace/GetItemsByPlacesController.php
* @route '/api/place/{place}/fetch-items'
*/
const GetItemsByPlacesController = (args: { place: string | { id: string } } | [place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemsByPlacesController.url(args, options),
    method: 'get',
})

GetItemsByPlacesController.definition = {
    methods: ["get","head"],
    url: '/api/place/{place}/fetch-items',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\GetItemsByPlacesController::__invoke
* @see app/Http/Controllers/WikiPlace/GetItemsByPlacesController.php
* @route '/api/place/{place}/fetch-items'
*/
GetItemsByPlacesController.url = (args: { place: string | { id: string } } | [place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { place: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { place: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            place: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        place: typeof args.place === 'object'
        ? args.place.id
        : args.place,
    }

    return GetItemsByPlacesController.definition.url
            .replace('{place}', parsedArgs.place.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\GetItemsByPlacesController::__invoke
* @see app/Http/Controllers/WikiPlace/GetItemsByPlacesController.php
* @route '/api/place/{place}/fetch-items'
*/
GetItemsByPlacesController.get = (args: { place: string | { id: string } } | [place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemsByPlacesController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetItemsByPlacesController::__invoke
* @see app/Http/Controllers/WikiPlace/GetItemsByPlacesController.php
* @route '/api/place/{place}/fetch-items'
*/
GetItemsByPlacesController.head = (args: { place: string | { id: string } } | [place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemsByPlacesController.url(args, options),
    method: 'head',
})

export default GetItemsByPlacesController